
import styled from "styled-components";

const ContentWrapperContainer = styled.div`
  position: relative;
`;

export default ContentWrapperContainer;